module.exports = __webpack_public_path__ + "assets/img/block-4b965879.png";